import { render, staticRenderFns } from "./CartTableTotalRow.vue?vue&type=template&id=138b6294&"
import script from "./CartTableTotalRow.vue?vue&type=script&lang=js&"
export * from "./CartTableTotalRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports